import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import FillApplicationSlot from "Communication/ApiClasses/FillApplicationSlot";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleFillApplicationSlotSaga(action) {
  console.log(action);
  yield put(
    doLoadingStart(STRINGS.JOIN_APPLICANT.API_KEYS.FILL_APPLICATION_SLOT)
  );
  const fillApplicationSlot = new FillApplicationSlot(action.data);
  try {
    const result = yield call(fillApplicationSlot.getData);
    yield put({
      type: actionTypes.FILL_APPLICATION_SLOT_SUCCESS,
      response: result,
      requestData: { ...action.requestData },
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.FILL_APPLICATION_SLOT_ERROR,
      error: e.message,
      requestData: { ...action.requestData },
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.JOIN_APPLICANT.API_KEYS.FILL_APPLICATION_SLOT)
    );
  }
}

// watcher
function* fillApplicationSlotWatcherSaga() {
  yield takeLatest(
    actionTypes.FILL_APPLICATION_SLOT,
    handleFillApplicationSlotSaga
  );
}

export default fillApplicationSlotWatcherSaga;
